<template>
  <div>
    <h3
      v-if="heading"
      class="heading"
    >
      {{ heading }}
    </h3>
    <div
      v-for="group in groupedWorkflows"
      :key="group.name"
      class="mb-3"
    >
      <div
        class="form-group"
      >
        <label class="text-200">{{ group.name }}</label>
        <el-select
          id="group.name"
          v-model="selectedWorkflow"
          class="select-primary dark"
          effect="dark"
          popper-class="select-primary"
          @change="showActions = true"
        >
          <el-option
            v-for="item in group.workflows"
            :key="item.name"
            :label="item.name"
            :value="item.name"
          />
        </el-select>
      </div>
    </div>

    <div v-if="allowActions && showActions">
      <base-button
        size="sm"
        type="primary"
        @click="$emit('save')"
      >
        Save Changes
      </base-button>
      <base-button
        size="sm"
        type="secondary"
        @click="reset"
      >
        Cancel
      </base-button>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
export default {
  name: "workflows-selection",
  props: {
    allowActions: {
      type: Boolean,
      default: false,
    },
    heading: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      groupedWorkflows: [],
      selectedWorkflow: "",
      showActions: false,
    };
  },
  watch: {
    availableWorkflows: {
      handler() {
        this.setupWorkflows();
      },
      immediate: true,
    },
  },
  computed: {
    ...mapGetters("data", [
      "availableWorkflows",
      "selectedWorkflows",
    ]),
  },
  methods: {
    setupWorkflows() {
      const me = this;
      this.selectedWorkflow = this.selectedWorkflows[0];
      this.groupedWorkflows = this.availableWorkflows
        .map((g) => {
          return { 
            name: g.name,
            workflows: g.workflows
              .map((w) => {
                return {
                  name: w,
                  checked: me.selectedWorkflows.indexOf(w) !== -1,
                };
              })
          };
        })
        .filter((x) => {
          return x.name !== "Video Analysis Settings";
        });
    },
    reset() {
      this.setupWorkflows();
      this.showActions = false;
    },
    selected() {
      // Currently, we only run one workflow at a time from this component, 
      // but we return it as an array.
      return [this.selectedWorkflow];
    },
  },
};
</script>

<style>

</style>
